import DivisionService from 'src/modules/division/divisionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'DIVISION_FORM';

const divisionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: divisionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await DivisionService.find(id);
      }

      dispatch({
        type: divisionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: divisionFormActions.INIT_ERROR,
      });

      getHistory().push('/division');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: divisionFormActions.CREATE_STARTED,
      });

      await DivisionService.create(values);

      dispatch({
        type: divisionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.division.create.success'),
      );

      getHistory().push('/division');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: divisionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: divisionFormActions.UPDATE_STARTED,
      });

      await DivisionService.update(id, values);

      dispatch({
        type: divisionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.division.update.success'),
      );

      getHistory().push('/division');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: divisionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default divisionFormActions;
